import {
  defineMessages,
  MessageDescriptor
} from 'react-intl';
import { LANGUAGE_KEY } from './language.constants';

const messages = Object.keys(LANGUAGE_KEY).reduce((acc, cur) => ({
  ...acc,
  [cur]: {
    id: cur,
    defaultMessage: cur,
  }
}), {}) as Record<LANGUAGE_KEY, MessageDescriptor>;

export const Translations = defineMessages<LANGUAGE_KEY>(messages);

// Define list of static messages that can be translated without passing any value in
export const StaticMessagesKeyMap: Record<LANGUAGE_KEY, boolean> = {
  [LANGUAGE_KEY.ENTRY_EXCEEDS_LENGTH_LIMIT]: true,
  [LANGUAGE_KEY.SHERPATH_AI_MATERIALS_LABEL]: true,
  [LANGUAGE_KEY.SHERPATH_AI_EBOOK_LABEL]: true,
  [LANGUAGE_KEY.VALUE_REQUIRED]: true,
};
